export default "__VITE_PUBLIC_ASSET__b41a7178__"